import { clamp, lerp } from '~/util';
import { DELTA_T } from '../waveform';
import type { WaveformApi } from '../waveform';
import type { RampWaveform } from '~/models/studio';
import type { Bounds, Vec2 } from '~/util';

export const wfRamp: WaveformApi<RampWaveform> = {
  samples: rampSamples,
  sampleAt: rampSampleAt,
  bounds: rampBounds,
  points: rampPoints,
  duration: rampDuration,
  area: rampArea
};

function rampDuration(wf: RampWaveform): number {
  return wf.duration;
}

function rampArea(wf: RampWaveform): number {
  return wf.duration * (wf.stop + wf.start) * 0.5 * DELTA_T;
}

function rampSamples(wf: RampWaveform): number[] {
  return Array.from({ length: wf.duration }, (_, i) => {
    return wf.start + ((wf.stop - wf.start) * i) / wf.duration;
  });
}

function rampSampleAt(wf: RampWaveform, t: number): number {
  return lerp(wf.start, wf.stop, clamp(Math.round(t) / wf.duration, 0, 1));
}

function rampBounds(wf: RampWaveform): Bounds {
  return {
    min: Math.min(wf.start, wf.stop),
    max: Math.max(wf.start, wf.stop)
  };
}

function rampPoints(wf: RampWaveform, xOffset: number): Vec2[] {
  return [
    { x: xOffset, y: wf.start },
    { x: xOffset + wf.duration, y: wf.stop }
  ];
}
